import { MetricData } from "@appsinti/ui-core/styles";
import styled from "styled-components";

const CustomMetricData = styled(MetricData)`
  padding-top: 3px;
  padding-bottom: 3px;

  @media screen and (max-height: 750px) {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  @media screen and (max-height: 710px) {
    padding-top: 1px;
    padding-bottom: 1px;
  }
`;

export default CustomMetricData;